package com.fireavert.reports_page.reports_page.data_models.responses

import com.fireavert.properties.shared.data_models.FireClaimData
import kotlinx.serialization.Serializable

@Serializable
data class ReportsFireClaimReportResponse(val fireClaimData: List<FireClaimData>, val yearStarted: Int)
